<div *ngIf="isOpen" [@translate] class="offcanvas flex flex-col fixed top-0 right-0 h-full overflow-y-auto bg-light z-[1010] w-full" [ngClass]="large ? 'lg:w-[700px]':'lg:w-[500px]'">
  <vl-icon class="cursor-pointer !absolute float-left top-[1.1rem] left-[1.3rem]" size="xl" status="primary" pack="font-awesome-solid" icon="arrow-right" status="primary" (click)=" close()"></vl-icon>

  <div class="offcanvas-header text-dark text-xl pt-3.5 px-12">
    <ng-content select="vg-offcanvas-header"></ng-content>
  </div>

  <div class="offcanvas-body overflow-auto pb-[1px] px-12 text-dark max-h-[88%] mt-5">
    <ng-content select="vg-offcanvas-body"></ng-content>
  </div>

  <div class="offcanvas-footer px-12 text-dark py-5">
    <ng-content select="vg-offcanvas-footer"></ng-content>
  </div>
</div>

<div *ngIf="isOpen" [@opacity] (click)="close()" class="offcanvas-backdrop fixed left-0 top-0 opacity-50 bg-dark-600 z-[1009] w-full h-full"></div>